export type Result<T, E> =
  | { ok: true; data: T }
  | { ok: false; error: E };

export const ok = <T,>(data: T): Result<T, never> => {
  return { ok: true, data };
};

export const err = <E,>(error: E): Result<never, E> => {
  return { ok: false, error };
};

export type RegisterErrorCode =
  | 'missing_welcome_bonus'
  | 'device_blocked'
  | 'invalid_affiliate'
  | 'google_cancelled'
  | 'email_exists'
  | 'general';

export interface RegisterError {
  code: RegisterErrorCode;
  message: string;
}
